'use client';

import { useEffect, useState } from 'react';
import { useAuth } from '@/lib/auth-context';
import { BookCarousel } from '@/components/book-carousel';
import { toBook, type ApiBook } from '@/lib/api';
import type { Book } from '@/types/catalog';

// Personalized shelf backed by /home/para-ti (real recommendations from the
// reader's loan/favorite history). Renders nothing for anonymous visitors.
export function ParaTiShelf() {
  const { loggedIn } = useAuth();
  const [books, setBooks] = useState<Book[]>([]);
  const [personalized, setPersonalized] = useState(false);

  useEffect(() => {
    if (!loggedIn) { setBooks([]); return; }
    let cancelled = false;
    fetch('/api/backend/home/para-ti')
      .then((r) => (r.ok ? r.json() : null))
      .then((d: { items: ApiBook[]; personalized: boolean } | null) => {
        if (!cancelled && d) {
          setBooks(d.items.map(toBook));
          setPersonalized(d.personalized);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [loggedIn]);

  if (!loggedIn || books.length === 0) return null;

  return (
    <BookCarousel
      title="Para ti"
      eyebrow={personalized ? 'Según tus lecturas' : 'Para empezar'}
      books={books}
    />
  );
}
